import { Helmet } from '@dr.pogodin/react-helmet';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import type { MultiLang } from '../config';
import Functions from '../functions';
import './assets/xwords.css';
import XwordsBreadcrumbs from './lib/XwordsBreadcrumbs';
import XwordsEntries from './lib/XwordsEntries';
import XwordsSearchFieldset from './lib/XwordsSearchFieldset';
import XwordsUtils from './lib/XwordsUtils';

interface Props {
    lang: MultiLang;
    type: number;
    catId: number;
    andor: string;
    term: string;
    start: number;
}

const XwordsSearch = (props: Props) => {
    const { lang, type, catId, andor, term, start } = props;
    const name = XwordsUtils.getName();
    const mtitle = Functions.mlang(name, lang);
    const title = Functions.mlang('[en]Search[/en][ja]検索[/ja]', lang);
    const result = XwordsUtils.search(type, catId, andor, term, start);
    const baseUrl = XwordsUtils.getSearchUrl(type, catId, andor, term);
    const etitle =
        result.total === 0
            ? Functions.mlang('[en]No entries found.[/en][ja]該当なし。再度お試しください。[/ja]', lang)
            : Functions.mlang(
                  '[en]' +
                      result.total +
                      ' entries found.[/en][ja]上記の条件で ' +
                      result.total +
                      ' 件見つかりました。[/ja]',
                  lang
              );
    return (
        <div className="xwords">
            <Helmet>
                <title>
                    {title} - {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{title}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            <XwordsBreadcrumbs lang={lang} isSearch={true} />
            <div className="row">
                <XwordsSearchFieldset lang={lang} type={type} catId={catId} andor={andor} term={term} />
            </div>
            <h4 className="title">{etitle}</h4>
            {result.total > 0 && <XwordsEntries lang={lang} baseUrl={baseUrl} result={result} start={start} />}
        </div>
    );
};

export default XwordsSearch;
